<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Duplicate Planner</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Subject"
              invalid-feedback="subject is required."
            >
              <b-form-input v-model="subjectObj.name" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Section"
              invalid-feedback="Section is required"
              ref="sec"
            >
              <v-select
                ref="sec"
                v-model="myObj.secID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sections"
                :reduce="(val) => val.secID"
                label="sec"
                :clearable="false"
                placeholder="Select section"
                @input="checkSub()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="Add()"
              :disabled="publishing"
              block
            >
              <b-spinner v-if="publishing" small type="grow" />
              <span v-else>Create</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-card>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12">
          <b-button
            v-if="rights.add"
            :disabled="dataLoading"
            @click="openNew()"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">Planner</span>
          </b-button>
        </b-col>

        <b-col xl="2" lg="3" md="4" sm="12" cols="12">
          <b-form-group label="" class="ml-md-0 ml-sm-0 ml-0 mb-0 pr-50">
            <v-select
              v-model="currentStaff"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="staff"
              label="name"
              @input="LoadData('subs')"
              :clearable="false"
              placeholder="Select staff"
            />
          </b-form-group>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1 d-flex align-items-center"
          xl="8"
          lg="6"
          md="4"
          sm="12"
          cols="12"
        >
          <b-form-group class="w-100">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input v-model="searchQuery" :placeholder="$t('Search') + '...'">
              </b-form-input>
            </b-input-group>
          </b-form-group>
          <!-- <b-button
            variant="outline-primary"
            v-b-tooltip.hover.top
            title="Export"
            class="btn-icon mb-1 ml-50"
            :disabled="exporting"
            @click="exportData()"
          >
            <b-spinner v-if="exporting" small varaint="primary" />
            <feather-icon v-else icon="UploadIcon" class="" />
          </b-button> -->
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        show-empty
        responsive
        hover
        :selectable="rights.edit"
        select-mode="single"
        @row-selected="openP($event[0].gridID, $event[0])"
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-50">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>
        <template #cell(cls)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(sec)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(tName)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(sub)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>

        <template #head(actions)="data">
          <div class="ml-2">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="">
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              title="Edit"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="openP(data.item.gridID, data.item)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <!-- <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.left
              title="Print"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Print(data.item)"
            >
              <feather-icon icon="PrinterIcon" class="" />
            </b-button> -->

            <b-button
              v-if="rights.edit || rights.add"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.right
              title="Duplicate"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="AddOpen(data.item)"
            >
              <feather-icon icon="CopyIcon" />
            </b-button>

            <b-button
              v-if="rights.delete"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.right
              title="Delete"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Delete(data.item.gridID)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BFormTextarea,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import store from "@/store";
import { avatarText } from "@core/utils/filter";
import flatPickr from "vue-flatpickr-component";
import { BFormSelect } from "bootstrap-vue";
//import Multiselect from "vue-multiselect";
import VueGallery from "vue-gallery";
import { forEach } from "postcss-rtl/lib/affected-props";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";

import * as XLSX from "xlsx";

export default {
  components: {
    flatPickr,
    BFormTextarea,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    // BFormCheckbox,
    BForm,
    BPagination,
    BSpinner,

    BDropdown,
    BDropdownItem,

    vSelect,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
        };
      });
    });
    this.$store.commit("setRights", right);
    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];

      if (!this.$route.params.id || this.$route.params.id == 0) {
        this.currentStaff = { id: 0, name: "Select staff" };
      } else this.currentStaff = { id: this.$route.params.id };
      // console.log(this.$route.params.id, this.currentStaff);
      this.loadStaff();
      this.LoadData();
    }

    // if (!this.$route.params.id || this.$route.params.id == 0) {
    //   this.currentStaff = { id: 0, name: "Select staff" };
    // } else this.currentStaff = { id: this.$route.params.id };
    // // console.log(this.$route.params.id, this.currentStaff);
    // this.loadStaff();
    // this.LoadData();
  },
  computed: {
    ...mapGetters({ cmbDepartment: "cmbDepartment" }),
    ...mapGetters({ data: "data" }),

    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.cls.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.sec.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.sub.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      rights: {},
      request: false,
      visibility1: false,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      sidebarTitle: "Add Subject",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      visibility: false,
      publishing: false,
      unpublishing: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      index: null,
      fields: [
        { label: "teacher", key: "tName" },
        { label: "class", key: "cls" },
        { label: "section", key: "sec" },
        { label: "subject", key: "sub" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      rangeDate: null,
      adding: false,
      showBtn: false,
      myObj: {},
      depObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      subjectObj: {},
      timeout: 10000,
      exporting: false,
      staff: [],
      currentStaff: { id: 0, name: "Select staff" },
      teacherData: [],
      sections: [],
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({ getDepartment: "getDepartment" }),
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    exportData() {
      this.exporting = true;

      const newData = this.items.map((el) => ({
        class: el.metaGrid.cls,
        section: el.metaGrid.sec,
        exam: el.metaGrid.exam,
        session: el.metaGrid.session,
        publish_from: el.datesheetGrid.publishedFrom,
        publish_till: el.datesheetGrid.publishedTo,
      }));

      const worksheet = XLSX.utils.json_to_sheet(newData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      XLSX.writeFile(workbook, "datesheet.xlsx");

      this.exporting = false;
    },

    Print(item) {
      // console.log(item);

      var url =
        "https://" +
        this.reportDomain +
        ".myskool.app/Exams/ShowDatesheet?dbb=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&gridID=" +
        item.gridID;

      window.open(url, "_blank");
    },
    openNew() {
      if (this.currentStaff.id == 0) {
        this.$bvToast.toast("Select the staff first", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else
        this.openP(0, {
          tID: this.currentStaff.id,
          tName: this.currentStaff.name,
        });
    },
    openP(id, item) {
      this.$router.push({
        name: "planner",
        params: {
          id: id,
          obj: item,
        },
      });
    },

    async Edit(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "Subjects/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      // console.log("editObj:", this.myObj);
      this.adding = false;
      this.visibility = true;
      this.sidebarTitle = "Edit Subject";
      this.sidebarButton = "Update";
      var elem = this.$refs["subject"];
      elem.state = undefined;
    },

    async AddOpen(item) {
      this.myObj = {
        id: item.gridID,
        tID: item.tID,
        clsID: item.clsID,
        secID: 0,
        subjectID: item.subID,
        campusID: this.$store.state.userData.cId,
      };
      this.subjectObj = {
        id: item.subID,
        name: item.sub,
      };
      // console.log(this.myObj);
      if (this.currentStaff.id == 0) {
        await this.LoadSubs(this.myObj.tID);
      }
      let ids = this.items.reduce((acc, row) => {
        if (row.clsID == this.myObj.clsID && row.tID == this.myObj.tID) {
          acc.push(row.secID);
        }
        return acc;
      }, []);
      this.sections = this.teacherData.filter(
        (el) =>
          el.clsID == this.myObj.clsID &&
          el.tID == this.myObj.tID &&
          !ids.includes(el.secID)
      );
      // console.log(this.sections);
      if (this.sections.length == 0) {
        this.$bvToast.toast("No more sections are assigned to teacher.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.visibility = true;
        var elem = this.$refs["sec"];
        elem.state = undefined;
      }
    },

    checkSec() {
      var elem = this.$refs["sec"];
      if (this.myObj.secID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    checkSub() {
      let subs = this.sections.find(
        (el) => el.secID == this.myObj.secID
      ).subjects;
      // console.log(this.subjectObj, subs);
      let cc = subs.find((el) => el.subID == this.subjectObj.id);
      if (!cc) return false;
      else return true;
    },

    hideSideBar() {
      this.visibility = false;
    },
    async loadStaff() {
      let st = {
        url:
          this.$store.state.domain +
          "staff/filter?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dptID=0&status=present",
        token: this.$store.state.userData.token,
      };
      this.staff = await this.get(st);

      if (this.$route.params.id > 0) {
        this.currentStaff = this.staff.find(
          (el) => el.id == this.$route.params.id
        );
        this.LoadSubs(this.currentStaff.id);
      }
    },
    async LoadSubs(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "TeacherClasses/LoadDataWebNew?db=" +
          this.$store.state.userData.db +
          "&tID=" +
          id,
        token: this.$store.state.userData.token,
      };
      this.teacherData = await this.get(obj);
      // console.log(this.teacherData);
    },
    async LoadData(text) {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "PlannerData/LoadGrid?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&tID=" +
          this.currentStaff.id,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);

      this.dataLoading = false;
      // console.log("subject", this.items);
      if (text == "subs") this.LoadSubs(this.currentStaff.id);
    },

    async Add() {
      if (this.checkSec() == true) {
        if (this.checkSub() == true) {
          this.publishing = true;

          var status = await this.post({
            url:
              this.$store.state.domain +
              "PlannerData/Duplicate?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Planner duplicated successfully!",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.publishing = false;
          if (status) {
            this.LoadData();
            this.visibility = false;
          }
        } else {
          this.$bvToast.toast(
            `Subject ${this.subjectObj.name} is not assigned to selected section`,
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            }
          );
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "PlannerData/Remove?id=" +
            id +
            "&db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          message: "Planner deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },
    async unPub() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "Do you want to unpublish this datesheet?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.unpublishing = true;
        this.myObj.isPublished = false;
        var status = await this.put({
          url:
            this.$store.state.domain +
            "DatesheetGrid/" +
            this.myObj.id +
            "?db=" +
            this.$store.state.userData.db,
          body: this.myObj,
          message: "Datesheet unpublished!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.unpublishing = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
